// extracted by mini-css-extract-plugin
module.exports = {"component":"tab-menu_component__bqtLc","slide":"tab-menu_slide__FFIG8"};